import axios from "../axios";

const updatePassword = async function (accessToken,password,newPassword) {
    try {
        const response = await axios.post('/profile/updatePassword', {
            password,
            newPassword
        }, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updatePassword;
